<script>
  import { onMount } from 'svelte';
  import { Table, Card, CardBody, CardHeader, Spinner } from 'sveltestrap';
  import { selectedGroup } from '../store.js';
  import http from '../api/http.js';
  export let  vesselObj;  
  
  let packageCatalogue = [];
  let errorMessage = ''
  
  async function getPackageCatalogue(){
    const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/vessels/packagecatalogue/${vesselObj.id}/${$selectedGroup}`);
    if(res.status === 200){
      packageCatalogue = await res.json();
      errorMessage = '';    
    }
    else{
      errorMessage = 'Error retrieving package catalogue.';
    }
  }
     
  </script>
  {#await getPackageCatalogue()}
    <Spinner color="primary" type="border"></Spinner>
  {:then}
    <Card style="min-height: 70vh;">    
      <CardHeader>
        <div class="d-flex">
          <h6 class="m-0 font-weight-bold">Package Catalogue</h6>
          <p class="text-danger ml-auto">{errorMessage}</p>
        </div>
      </CardHeader>
      <CardBody>
        {#if packageCatalogue.length < 1}
        <p>No packages onboard.</p>
          {:else}
            <Table responsive id="groupVesselTable">
              <thead>
                <th>Name</th>
                <th>Version</th>
                <th>Type</th>
              </thead>
              <tbody>
                {#each packageCatalogue as entry}
                  <tr id="package-catalogue-{entry.id}">
                    <td>{entry.name}</td>
                    <td>{entry.version}</td>
                    <td>{entry.type}</td>
                  </tr>
                {/each}
              </tbody>
            </Table>
        {/if}
      </CardBody>
    </Card>   
  {/await}      